import apiRequest from 'client/helpers/apiRequest';
import SearchPage from '@interfaces/search-page';
import { SearchRequestParams } from '@interfaces/search-request-params';

export const fetchSearch = (_params: SearchRequestParams) => {
    const { page: pageNumber = 1, type, text } = _params;
    const params = { pageNumber, type, text };

    return apiRequest.get<SearchPage>('/api/search', { params });
};
